import { connect } from "formik";

import Broker from "./Broker";

export default connect(Broker);
